// extracted by mini-css-extract-plugin
export default {"one":"SecOne_one__UPiw4","main":"SecOne_main__xrTUT","gif":"SecOne_gif__B04Fg"};